export const RESEND_EMAIL_DELAY_SECONDS = 30;

export interface InactiveUserPasswordResetFormProps {
  isFormInModal?: boolean;
}

export interface ResendEmailError {
  status: string;
  message: string;
  code: string;
  data: null;
}

export interface MailProviderButtonContent {
  logoUrl: string;
  label: string;
}
